import { render, staticRenderFns } from "./FEmptyState.vue?vue&type=template&id=bed7d480&scoped=true&"
import script from "./FEmptyState.vue?vue&type=script&lang=js&"
export * from "./FEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./FEmptyState.vue?vue&type=style&index=0&id=bed7d480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed7d480",
  null
  
)

export default component.exports